export default [
  { key: 'USD', text: 'USD', value: 'USD' },
  { key: 'CAD', text: 'CAD', value: 'CAD' },
  { key: 'GBP', text: 'GBP', value: 'GBP' },
  { key: 'AUD', text: 'AUD', value: 'AUD' },
  { key: 'EUR', text: 'EUR', value: 'EUR' }
];
